// extracted by mini-css-extract-plugin
export default {"entryItem":"AttachmentBrowser_entryItem__jhbXN"};